import { api } from "./api";

export function formatBytes(bytes) {
  if (!bytes) return "0 B";
  const kb = bytes / 1024;
  if (kb < 1) return `${bytes} B`;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
}

export function isImage(a) {
  return (a?.content_type || "").startsWith("image/");
}

export function attachmentUrl(a, { email, token } = {}) {
  const base = process.env.REACT_APP_BACKEND_URL;
  const params = new URLSearchParams();
  if (email) params.set("email", email);
  if (token) params.set("auth", token);
  const q = params.toString();
  return `${base}/api/attachments/${a.id}${q ? `?${q}` : ""}`;
}

export async function uploadAttachment(ticketId, file, { email } = {}) {
  const fd = new FormData();
  fd.append("file", file);
  const params = email ? `?email=${encodeURIComponent(email)}` : "";
  const { data } = await api.post(`/tickets/${ticketId}/attachments${params}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
